module.exports = __webpack_public_path__ + "static/undraw_operating_system_4lr6-c8753ac5455fdc733db6d255797c9848.svg";